const getRandom = (arr, n) => {
    if(n <= 0 || !arr){
        return []
    }
    var result = new Array(n),
        len = arr.length,
        taken = new Array(len);
    if (n > len)
        len = n;
    while (n--) {
        var x = Math.floor(Math.random() * len);
        result[n] = arr[x in taken ? taken[x] : x];
        taken[x] = --len;
    }
    return result;
}

export default getRandom


// WEBPACK FOOTER //
// ./src/app/util/getRandom.js